import i18next from 'i18next';
import { toast } from 'sonner';
import { sdk } from '@/lib/api/sdk-instance.js';

const emptyBuckets = () => ({
    tickets: [],
    incidents: [],
    problems: [],
    changeRequests: [],
});

export class ItsmIntegration {
    async fetchSummary() {
        try {
            const payload = await sdk.get('/itsm/summary');
            const envelope = payload?.success !== undefined ? payload : payload?.data;
            return {
                success: envelope?.success !== false,
                data: envelope?.data ?? null,
            };
        } catch (error) {
            return { success: false, error: error.message, data: null };
        }
    }

    async unifiedSearch(term, limit = 25) {
        try {
            const payload = await sdk.get('/itsm/unified-search', { params: { q: term, limit } });
            const envelope = payload?.success !== undefined ? payload : payload?.data;
            if (!envelope?.success || !envelope.data) {
                toast.error(
                    i18next.t('itsmHub:searchInvalidResponse', { defaultValue: 'Invalid search response' }),
                );
                return { success: false, data: emptyBuckets() };
            }
            return {
                success: true,
                data: {
                    tickets: envelope.data.tickets || [],
                    incidents: envelope.data.incidents || [],
                    problems: envelope.data.problems || [],
                    changeRequests: envelope.data.changeRequests || [],
                },
            };
        } catch {
            toast.error(i18next.t('itsmHub:searchFailed', { defaultValue: 'Search failed' }));
            return { success: false, data: emptyBuckets() };
        }
    }
}
